// extracted by mini-css-extract-plugin
export default {"inputWrapper":"LanguageTab_inputWrapper__6ng0g"};